import { Breadcrumb } from 'antd';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist } from '@util/data/is-exist';

import { BreadcrumbOptionList } from './header.options';
import { Wrapper } from './header.style';

export const Header = () => {
  const routeName = useStoreSelector((state) => state.route.name);

  const items = useMemo(
    () =>
      (BreadcrumbOptionList[routeName] ?? []).map(({ link, title }) => ({
        title: isExist(link) ? <Link to={link.path}>{title}</Link> : title,
      })),
    [routeName],
  );

  return (
    <Wrapper>
      <Breadcrumb items={items} />
    </Wrapper>
  );
};
